import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { API_URL } from '@/constants';
import { simpleFetch } from '@/utils/simpleFetch';

// Flujo nTipo 2 (nuevo), separado por completo del flujo viejo (useSurvey.tsx
// / SurveyWizard / UserInfoForm, que están acoplados al shape de
// SP_Obtener_Encuesta). Este hook consume CONFIG.SP_OBTEN_EVALUACION vía
// Obten/EvaluacionPorId — shape propio, sin relación con EncuestaInfo.

export interface Seccion {
    nEvaluacion: number,
    nSeccion: number,
    cSeccion: string,
    nTipo: number,
    bMostrarSeccion: number,
    bActivo: boolean,
    dFechaRegistro: string,
    nUsuarioRegistro: number
}

export interface Reactivo {
    nEvaluacion: number,
    nSeccion: number,
    nReactivo: number,
    cReactivo: string,
    nTipo: number,
    bMostrarObservaciones: boolean,
    bOpcional: number,
    nReactivoDepende: number | null,
    nPlantillaRespuestas: number,
    bActivo: boolean,
    dFechaRegistro: string,
    nUsuarioRegistro: number
}

export interface ReactivoOpcion {
    nEvaluacion: number,
    nSeccion: number,
    nReactivo: number,
    nOpcion: number,
    cOpcion: string,
    nValorPonderacion: number,
    cValor: string | null,
    bActivo: boolean,
    dFechaRegistro: string,
    nUsuarioRegistro: number,
    bRequiereObservacion: boolean
}

export interface RespuestaGuardada {
    nSeccion: number;
    nReactivo: number;
    nValor: number | null;
    cValor: string | null;
}

export interface TokenExtraInfo {
    cDataDescripcion: string;
    cDataValor: string;
}

export interface EvaluacionDetalle {
    nEvaluacion: number;
    nEmpresa: number;
    cCodigo: string;
    cDescripcion: string;
    nTipo: number;
    cMensajeInicial: string;
    cMensajeFinal: string | null;
    cColorPrimario: string;
    cColorSecundario: string;
    cLogoUrl: string;
    cBackgroundImageUrl: string;
    bActivo: boolean;
    dFechaRegistro: string;
    nUsuarioRegistro: number;
    MetaInfo: unknown[];
    Secciones: Seccion[];
    Reactivos: Reactivo[];
    ReactivosOpciones: ReactivoOpcion[];
    EstatusEvaluacion: number;
    // Puede llegar undefined: el recordset de respuestas guardadas aún no lo
    // envía CONFIG.SP_OBTEN_EVALUACION (pendiente en backend).
    RespuestasGuardadas: RespuestaGuardada[];
    TokenExtraInfo: TokenExtraInfo[];
}

const useEvaluacion = () => {
    const { cToken } = useParams();
    const [evaluacion, setEvaluacion] = useState<EvaluacionDetalle>();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    const handleGetEvaluacion = async () => {
        setLoading(true);

        const response = await simpleFetch<EvaluacionDetalle>({
            url: `${API_URL}Obten/EvaluacionToken/${cToken}`,
            method: 'POST',
        });

        if (response.success) {
            setEvaluacion(response.data);
        } else {
            setNotFound(true);
        }

        setLoading(false);
    };

    // El fetch se dispara en cada mount (deps []) para que re-navegar al mismo
    // cToken —caso "salir y volver atrás" sin cambio de params— haga una
    // petición fresca. La re-mount por cambio de token la fuerza el router con
    // key={cToken} en <EvaluacionView />.
    useEffect(() => {
        if (cToken) {
            handleGetEvaluacion();
        }
    }, []);

    return {
        evaluacion,
        loading,
        notFound,
        refetch: handleGetEvaluacion,
    };
};

export default useEvaluacion;
